import Head from 'next/head'
import {useParams} from 'next/navigation'
import {useMemo} from 'react'

import {useQuery} from '@tanstack/react-query'

import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {getContentQuery} from '$queries/insurance/contentQuery'
import CONFIG from '$share/config'
import buildUrl from '$utils/buildUrl'

export default function ContentOgMetaTag() {
    const {id} = useParams()

    const {data: contentData} = useQuery({
        ...getContentQuery.query({params: {contentId: +id}}),
    })

    const ogUrl = useMemo(() => {
        return buildUrl({pathname: INTERNAL_ROUTES['INSURANCE_CONTENTS_[ID]'], query: {id}})
    }, [id])

    return (
        <Head>
            <meta property="og:title" content={contentData?.title} />
            <meta
                property="og:image"
                content={
                    contentData?.imageUrlSquare ||
                    contentData?.imageUrl ||
                    `${CONFIG.FE_CDN_ORIGIN}/static/public/image/npay_og_260x260.png`
                }
            />
            <meta property="og:url" content={ogUrl} />
            <meta property="og:description" content={contentData?.subTitle} />
        </Head>
    )
}
